// Вспомогательные функции для AML-модуля
import { AmlCaseStatus, AmlRiskLevel, DecisionType } from './types';

// Метка статуса кейса
export const STATUS_LABELS: Record<AmlCaseStatus, string> = {
  [AmlCaseStatus.PENDING]:   'Ожидает',
  [AmlCaseStatus.IN_REVIEW]: 'На проверке',
  [AmlCaseStatus.APPROVED]:  'Одобрено',
  [AmlCaseStatus.REJECTED]:  'Отклонено',
  [AmlCaseStatus.ESCALATED]: 'Эскалировано',
  [AmlCaseStatus.OVERDUE]:   'Просрочено',
};

// Bootstrap-вариант бейджа для статуса
export const STATUS_BADGE: Record<AmlCaseStatus, string> = {
  [AmlCaseStatus.PENDING]:   'warning',
  [AmlCaseStatus.IN_REVIEW]: 'info',
  [AmlCaseStatus.APPROVED]:  'success',
  [AmlCaseStatus.REJECTED]:  'danger',
  [AmlCaseStatus.ESCALATED]: 'dark',
  [AmlCaseStatus.OVERDUE]:   'danger',
};

// Метка уровня риска
export const RISK_LABELS: Record<AmlRiskLevel, string> = {
  [AmlRiskLevel.LOW]:      'Низкий',
  [AmlRiskLevel.MEDIUM]:   'Средний',
  [AmlRiskLevel.HIGH]:     'Высокий',
  [AmlRiskLevel.CRITICAL]: 'Критический',
};

// Bootstrap-вариант бейджа для уровня риска
export const RISK_BADGE: Record<AmlRiskLevel, string> = {
  [AmlRiskLevel.LOW]:      'success',
  [AmlRiskLevel.MEDIUM]:   'warning',
  [AmlRiskLevel.HIGH]:     'danger',
  [AmlRiskLevel.CRITICAL]: 'danger',
};

// Метки типов решений
export const DECISION_LABELS: Record<DecisionType, string> = {
  approve:      'Одобрить',
  reject:       'Отклонить',
  escalate:     'Эскалировать',
  request_info: 'Запросить информацию',
};

// Bootstrap-вариант кнопки для типа решения
export const DECISION_BUTTON_VARIANT: Record<DecisionType, string> = {
  approve:      'success',
  reject:       'danger',
  escalate:     'dark',
  request_info: 'info',
};

// Форматирование даты и времени
export const formatDateTime = (iso: string): string => {
  try {
    return new Date(iso).toLocaleString('ru-RU', {
      day:    '2-digit',
      month:  '2-digit',
      year:   'numeric',
      hour:   '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
};

// Форматирование только даты
export const formatDate = (iso: string): string => {
  try {
    return new Date(iso).toLocaleDateString('ru-RU');
  } catch {
    return iso;
  }
};

// Форматирование суммы с валютой
export const formatAmount = (amount: number, currency: string): string => {
  try {
    if (['ETH', 'BTC', 'USDT', 'USDC'].includes(currency.toUpperCase())) {
      return `${amount.toFixed(4)} ${currency}`;
    }
    return new Intl.NumberFormat('ru-RU', {
      style:    'currency',
      currency: currency === 'RUB' ? 'RUB' : 'USD',
      maximumFractionDigits: 2,
    }).format(amount).replace('$', currency !== 'RUB' ? currency + ' ' : '');
  } catch {
    return `${amount} ${currency}`;
  }
};

// Признак просроченности
export const isOverdue = (dueAt: string, status: AmlCaseStatus): boolean => {
  if ([AmlCaseStatus.APPROVED, AmlCaseStatus.REJECTED, AmlCaseStatus.ESCALATED].includes(status)) {
    return false;
  }
  return new Date(dueAt) < new Date();
};

// Цвет скора риска (0-100)
export const scoreColor = (score: number): string => {
  if (score >= 80) return 'danger';
  if (score >= 60) return 'warning';
  if (score >= 40) return 'info';
  return 'success';
};

// Иконка (unicode) для типа события таймлайна
export const timelineIcon: Record<string, string> = {
  case_created:        '📋',
  rule_triggered:      '⚠️',
  assigned:            '👤',
  comment:             '💬',
  info_requested:      '❓',
  info_received:       '📎',
  decision_made:       '✅',
  escalated:           '🔺',
  transaction_blocked: '🚫',
  overdue:             '⏰',
};
